import { render, staticRenderFns } from "./board.vue?vue&type=template&id=0fe6ee78&scoped=true"
import script from "./board.vue?vue&type=script&lang=js"
export * from "./board.vue?vue&type=script&lang=js"
import style0 from "./board.vue?vue&type=style&index=0&id=0fe6ee78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe6ee78",
  null
  
)

export default component.exports